import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Field} from 'redux-form';

import {
  FieldRow,
  OrderTypeLabel,
  ChooseServiceTypeOption,
  ServiceTypeOptionDiv,
  OptionLabel,
  TableNumberLabel
} from './CheckoutPage.style';

import {validateRequired} from '../../helpers/formValidation.helper';
import {SERVICE_TYPE} from '../../constants/constant';
import RenderRadioButton from './RenderRadioButton';

const ServiceType = ({
    isValidating,
    openForCollection,
    openForDelivery,
    restaurantModes,
    setServiceType,
    tableId
  }) => {
  const renderCollectionOption = !tableId && restaurantModes.collection && (
    <ServiceTypeOptionDiv>
      <OptionLabel
        htmlFor="orderForCollection"
        isDisabled={!openForCollection}
      >
        <Field
          id="orderForCollection"
          type="radio"
          name="serviceType"
          value={SERVICE_TYPE.COLLECTION}
          component={RenderRadioButton}
          isDisabled={!openForCollection || isValidating}
          callback={setServiceType}
          validate={[validateRequired]}
        />
        <FormattedMessage id="checkout.collection" />
      </OptionLabel>
    </ServiceTypeOptionDiv>
  );

  const renderDeliveryOption = !tableId && restaurantModes.delivery && (
    <ServiceTypeOptionDiv>
      <OptionLabel
        htmlFor="orderForDelivery"
        isDisabled={!openForDelivery}
      >
        <Field
          id="orderForDelivery"
          type="radio"
          name="serviceType"
          value={SERVICE_TYPE.DELIVERY}
          component={RenderRadioButton}
          isDisabled={!openForDelivery || isValidating}
          callback={setServiceType}
          validate={[validateRequired]}
        />
        <FormattedMessage id="checkout.delivery" />
      </OptionLabel>
    </ServiceTypeOptionDiv>
  );

  const renderTableId = tableId && (
    <TableNumberLabel> table {tableId}</TableNumberLabel>
  );
  return (
    <FieldRow
      nomargin
      hasLink={!!tableId}
    >
      <OrderTypeLabel>
        <FormattedMessage id="checkout.myOrder" />
      </OrderTypeLabel>
      <ChooseServiceTypeOption>
        {renderCollectionOption}
        {renderDeliveryOption}
        {renderTableId}
      </ChooseServiceTypeOption>
    </FieldRow>
  );
};

ServiceType.propTypes = {
  isValidating: PropTypes.bool.isRequired,
  openForCollection: PropTypes.bool.isRequired,
  openForDelivery: PropTypes.bool.isRequired,
  restaurantModes: PropTypes.object.isRequired,
  setServiceType: PropTypes.func.isRequired,
  tableId: PropTypes.string
};

export default ServiceType;



// WEBPACK FOOTER //
// ./containers/CheckoutPage/ServiceType.js